<app-navbar />

<main id="main-content">
  <section class="page-hero">
    <div class="container">
      <app-breadcrumb [trail]="[{ label: 'Feedback' }]" />
      <span class="eyebrow">We are listening</span>
      <h1>Share feedback on VerifyDeceased</h1>
      <p>
        VerifyDeceased gets better because of the teams that use it. Tell us what is working, what
        could be smoother and what you would like to see next.
      </p>
    </div>
  </section>

  <section class="section">
    <div class="container narrow">
      <div class="feedback-card">
        @if (submitted()) {
          <div class="feedback-success">
            <span class="feedback-success-icon" aria-hidden="true">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </span>
            <h2>Thank you for the feedback</h2>
            <p>
              We read every message and use it to shape what we build next. If you asked us to follow
              up, we will be in touch soon.
            </p>
            <a class="btn btn-outline" [routerLink]="[routes.home.url]">Back to home</a>
          </div>
        } @else {
          <h2>Share your thoughts</h2>
          <p class="feedback-lead">It takes less than a minute and it genuinely helps.</p>

          <form (ngSubmit)="submit()" #feedbackForm="ngForm">
            <div class="form-group">
              <label>How would you rate your experience?</label>
              <div class="rating-row" role="radiogroup" aria-label="Rating">
                @for (star of [1, 2, 3, 4, 5]; track star) {
                  <button type="button" class="rating-star" [class.active]="star <= rating()"
                    (click)="setRating(star)" [attr.aria-label]="star + ' star'">
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2l2.9 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l7.1-1.01L12 2z" />
                    </svg>
                  </button>
                }
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="name">Name</label>
                <input id="name" name="name" class="form-control" [(ngModel)]="model.name"
                  placeholder="Optional" />
              </div>
              <div class="form-group">
                <label for="email">Email</label>
                <input id="email" name="email" type="email" class="form-control"
                  [(ngModel)]="model.email" placeholder="If you would like a reply" />
              </div>
            </div>

            <div class="form-group">
              <label for="topic">What is this about?</label>
              <select id="topic" name="topic" class="form-control" [(ngModel)]="model.topic">
                <option value="" disabled>Select a topic</option>
                @for (topic of topics; track topic) {
                  <option [value]="topic">{{ topic }}</option>
                }
              </select>
            </div>

            <div class="form-group">
              <label for="message">Your feedback</label>
              <textarea id="message" name="message" class="form-control" rows="5" required
                [(ngModel)]="model.message" placeholder="Tell us what is on your mind"></textarea>
            </div>

            <button type="submit" class="btn btn-primary btn-block btn-lg"
              [disabled]="feedbackForm.invalid">Send feedback</button>
          </form>
        }
      </div>
    </div>
  </section>
</main>

<app-footer />
